import React from "react"

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Typography,
} from "@mui/material"
import { t, Trans } from "@lingui/macro"
import { EditorState } from "draft-js"
import { Editor } from "react-draft-wysiwyg"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"

interface ContactMessageDialogProps {
    open: boolean
    sending: boolean
    accountManagerName: string
    subject: string
    onSubjectChange: (value: string) => void
    editorState: EditorState
    onEditorStateChange: (state: EditorState) => void
    canSend: boolean
    onClose: () => void
    onSend: () => void
}

export const ContactMessageDialog = ({
    open,
    sending,
    accountManagerName,
    subject,
    onSubjectChange,
    editorState,
    onEditorStateChange,
    canSend,
    onClose,
    onSend,
}: ContactMessageDialogProps) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>
                <Trans id="match-details.contact.modal.title">Nuovo messaggio</Trans>
            </DialogTitle>
            <DialogContent>
                <TextField
                    fullWidth
                    label={t({ id: "match-details.contact.modal.recipient", message: "Destinatario" })}
                    value={accountManagerName}
                    InputProps={{ readOnly: true }}
                    sx={{ mb: 2, mt: 1 }}
                />
                <TextField
                    fullWidth
                    label={t({ id: "match-details.contact.modal.subject", message: "Oggetto" })}
                    value={subject}
                    onChange={(event) => onSubjectChange(event.target.value)}
                    sx={{ mb: 2 }}
                />
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    <Trans id="match-details.contact.modal.message">Messaggio</Trans>
                </Typography>
                <Editor
                    editorState={editorState}
                    onEditorStateChange={onEditorStateChange}
                    toolbar={{
                        options: ["inline", "list", "link"],
                        inline: {
                            options: ["bold", "italic"],
                        },
                        list: {
                            options: ["unordered", "ordered"],
                        },
                        link: {
                            options: ["link"],
                        },
                    }}
                    toolbarStyle={{
                        backgroundColor: "#11347B",
                        borderColor: "#11347B",
                    }}
                    editorStyle={{
                        minHeight: "120px",
                        maxHeight: "220px",
                        border: "1px solid lightgray",
                        overflow: "auto",
                        padding: "8px",
                    }}
                    placeholder={t({ id: "match-details.contact.modal.placeholder", message: "Scrivi il messaggio..." })}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={sending}>
                    <Trans id="common.cancel">Annulla</Trans>
                </Button>
                <Button
                    onClick={onSend}
                    variant="contained"
                    disabled={!canSend}
                >
                    <Trans id="match-details.contact.modal.send">Invia messaggio</Trans>
                </Button>
            </DialogActions>
        </Dialog>
    )
}
